import { string, object,ref } from "yup";

export const resetPasswordValidationSchema = (t: any) => object().shape({
    newPassword: string().required(t("validationMessages.fieldIsRequired",{field:t("fields.password")})),
    confirmPassword:string().oneOf([ref('newPassword'),null],t("validationMessages.passwordsNotMatch"))
})